import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import socket from "../socket/socket";
import OrderStatusBadge from "./OrderStatusBadge";
import Timer from "./ongoing-orders/Timer";

const DelayedOrderEvents = () => {
  const [delayedEvents, setDelayedEvents] = useState([]);
  const [clearEventId, setClearEventId] = useState(null);
  const token = localStorage.getItem("token");

  const fetchDelayedOrderEvents = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}order/delayed-order-events`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setDelayedEvents(res.data.data);
        }
      })
      .catch(console.error);
  };

  const clearEvent = () => {
    if (clearEventId?.trim()) {
      socket.emit("admin:clear-alert", { orderId: clearEventId });
    }
    setClearEventId(null);
  };

  useEffect(() => {
    fetchDelayedOrderEvents();

    const listenDelayedOrderEvents = (data) => {
      if (
        data &&
        data?.alertedList &&
        Array.isArray(data?.alertedList) &&
        data?.alertedList?.length > 0
      ) {
        const list = data?.alertedList;
        setDelayedEvents((prev) => [...prev, ...list]);
      }
    };

    const listenClearDelayedOrderEvents = (data) => {
      if (data && data?.orderId) {
        const orderId = data?.orderId;
        setDelayedEvents((prev) => prev.filter((a) => a.id !== orderId));
      }
    };

    const listenOrderEvents = (data) => {
      if (data && (data?.orderId || data?._id)) {
        const orderId = data?._id ?? data?.orderId;
        setDelayedEvents((prev) => prev.filter((a) => a.id !== orderId));
      }
    };

    socket.on(`admin:delayed-order-alerts`, listenDelayedOrderEvents);
    socket.on("admin:alert-cleared", listenClearDelayedOrderEvents);
    socket.on("admin:ordersUpdate", listenOrderEvents);

    return () => {
      socket.off(`admin:delayed-order-alerts`, listenDelayedOrderEvents);
      socket.off("admin:alert-cleared", listenClearDelayedOrderEvents);
      socket.off("admin:ordersUpdate", listenOrderEvents);
    };
  }, []);
  return (
    <>
      <div className="card mb-5 h-100">
        <div className="card-header">
          <div className="card-title">Delayed Order Events</div>
        </div>

        <div className="card-body py-4">
          {delayedEvents?.length > 0 ? (
            <div className="table-responsive">
              <table className="table align-middle table-row-dashed fs-6 gy-5">
                <thead>
                  <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                    <th className="text-center min-w-100px">Order Id</th>
                    <th className="text-center min-w-100px">Status</th>
                    <th className="text-center min-w-100px">Time</th>
                    <th className="text-center min-w-100px">Actions</th>
                  </tr>
                </thead>

                <tbody className="text-gray-600 fw-semibold">
                  {delayedEvents &&
                    delayedEvents?.map((item, index) => {
                      return (
                        <tr className="text-center" key={index}>
                          <td>
                            <Link
                              target="_blank"
                              to={`/orders/order-details/${item?.id}`}
                            >
                              {item?.orderId}
                            </Link>
                          </td>
                          <td>
                            <OrderStatusBadge status={item?.status} />
                          </td>
                          <td>
                            <Timer date={item?.delayedSince} />
                          </td>
                          <td>
                            <button
                              className="btn btn-outline btn-danger btn-sm btn-color-white btn-sm"
                              title="Close Alert"
                              onClick={() => setClearEventId(item?.id)}
                            >
                              Close
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center w-100">
              <img
                className="w-25 mx-auto py-20"
                src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                alt="no-content"
              />
            </div>
          )}
        </div>
      </div>
      {/* start :: delete */}
      <div
        className={
          clearEventId !== null && clearEventId?.trim()
            ? "modal fade show d-block"
            : "modal fade"
        }
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content text-center bg-danger text-light">
            <div className="modal-header">
              <h5 className="modal-title mx-auto text-light">CLOSE</h5>
            </div>
            <div className="modal-body">
              <p className="h4 text-light">Are You Sure ?</p>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                onClick={() => {
                  setClearEventId(null);
                }}
                type="button"
                className="btn btn-light btn-sm"
                data-bs-dismiss="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-light btn-sm"
                onClick={clearEvent}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* end :: delete */}
    </>
  );
};

export default DelayedOrderEvents;
